import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Alert, Row, Col, Panel, Well, Button } from 'react-bootstrap';
import moment from 'moment';
import map from 'lodash/map';
import pullAll from 'lodash/pullAll';
import reduce from 'lodash/reduce';
import union from 'lodash/union';
import RouteInfo from '../../../../components/RouteInfo';
import AbnormalityInfo from '../../../abnormalities/components/AbnormalityInfo';
import Reasons from '../../../abnormalities/components/Reasons';
import { loadAbnormalityAnalysis, getAbnormalityAnalysis, getIsFetching } from '../../analysisDuck';
import { getIsPending, getError } from '../../recoveryActionsDuck';
import { clearManifests } from '../../../manifests/duck';
import TapModal from '../components/modals/TapModal';
import SpecialModal from '../components/modals/SpecialModal';
import SlidePullModal from '../components/modals/SlidePullModal';
import UnrelatedManifestsModal from '../components/UnrelatedManifestsModal';
import ManifestTimeline from '../../../../components/ManifestTimeline/index';
import AbnormalityManifestsTable from '../components/AbnormalityManifestsTable';
import AssigneeInfo from '../../../../components/AssigneeInfo';
import BlowoutRepetitions from '../components/BlowoutRepetitions';
import Loader from '../../../../components/Loader/index';
import { validateFields } from '../../../../shared/utils/handleBlowoutValidations';
import { ABNORMALITIES } from '../../../../constants';
import { hideSeverityColumn } from '../../../../shared/utils/manifest';
import { createAbnormalityAnalysisBreadcrumb } from '../../../../shared/utils/breadcrumbs';
import { replaceArrow } from '../../../../shared/utils/string';

//Abnormality Analysis Screen
class CreateRecoveryAction extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            allManifestsSelected: false,
            openTapModal: false,
            openPullForwardModal: false,
            openSpecialModal: false,
            openSlideModal: false,
            openUnrelatedManifestsModal: false,
            selectedAbnManifestIds: [],
            selectedManifestIds: [],
            validations: {},
        };
    }

    componentWillMount() {
        this.props.clearManifests();
        this.props.loadAbnormalityAnalysis(this.props.params.abnormalityId);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.isPending && !nextProps.isRejected) {
            //if recovery action is created redirect back to abnormality
            console.log(
                '[AbnormalityAnalysis] Redirecting to abnormality because the rec. action request was pending and was not rejected...'
            );
            this.props.router.push(
                `/runs/${this.props.params.id}/abnormality/${this.props.params.type}/${
                    this.props.params.abnormalityId
                }`
            );
        }
    }

    handleOpenModal = modal => {
        const { selectedAbnManifestIds } = this.state;
        if (
            modal === 'openPullForwardModal' ||
            modal === 'openSlideModal' ||
            modal === 'openTapModal' ||
            modal === 'openSpecialModal'
        ) {
            //TODO: probably for all/most of them
            const isSlide = modal === 'openSlideModal';
            const validations = validateFields({
                selectedManifests: selectedAbnManifestIds,
                isSlide,
            });
            this.setState({ validations });
            if (!validations.manifests) {
                this.setState({ [modal]: true });
            }
        } else {
            this.setState({ [modal]: true });
        }
    };

    handleCloseModal = modal => {
        this.setState({ [modal]: false });
    };

    handleSingleManifestSelection = (row, isSelected) => {
        this.canUpdate = true;
        let selAbnManIds = [...this.state.selectedAbnManifestIds];
        let selManIds = [...this.state.selectedManifestIds];
        let errors = {};

        if (isSelected) {
            selAbnManIds.push(row.abnormalityManifestId);
            selManIds.push(row.manifest.manifestId);
            errors = validateFields({
                tempManifests: [{ ...row, palletAmount: row.totalPallets }],
                isSlide: true,
            });
            this.setState({ validations: errors });

            if (this.state.validations.manifests) {
                let tempVal = this.state.validations;
                delete tempVal.manifests;
                this.setState({ validations: tempVal });
            }
            if (this.state.validations.pallets) {
                let tempVal = this.state.validations;
                delete tempVal.pallets;
                this.setState({ validations: tempVal });
            }
        } else {
            const index = selAbnManIds.indexOf(row.abnormalityManifestId);
            if (index > -1) {
                selAbnManIds.splice(index, 1);
                selManIds.slice(selManIds.indexOf(row.manifest.manifestId), 1);
            }
            if (row.totalPallets >= 10 && this.state.validations.moreThan10Pallets) {
                let tempVal = this.state.validations;
                delete tempVal.moreThan10Pallets;
                this.setState({ validations: tempVal });
            }
        }
        this.setState({
            selectedAbnManifestIds: selAbnManIds,
            selectedManifestIds: selManIds,
        });
    };

    handleAllManifestsSelection = (isSelected, rows) => {
        this.canUpdate = true;
        let selAbnManIds = [...this.state.selectedAbnManifestIds];
        let selManIds = [...this.state.selectedManifestIds];
        let abnManifestIds = map(rows, r => r.abnormalityManifestId);
        let manifestIds = map(rows, r => r.manifest.manifestId);

        selAbnManIds = isSelected
            ? union(selAbnManIds, abnManifestIds)
            : pullAll(selAbnManIds, abnManifestIds);
        selManIds = isSelected ? union(selManIds, manifestIds) : pullAll(selManIds, manifestIds);

        if (this.state.validations.manifests) {
            let tempVal = this.state.validations;
            delete tempVal.manifests;
            this.setState({ validations: tempVal });
        }

        if (this.state.validations.pallets) {
            let tempVal = this.state.validations;
            delete tempVal.pallets;
            this.setState({ validations: tempVal });
        }

        this.setState({
            selectedAbnManifestIds: selAbnManIds,
            selectedManifestIds: selManIds,
        });
    };

    selectAllManifestsForAllManifestGroups = () => {
        const allManifestsSelected = !this.state.allManifestsSelected;
        const { manifestGroups } = this.props.abnormalityAnalysis;
        const allManifests = reduce(
            manifestGroups,
            (accumulator, manifestGroup) => [...accumulator, manifestGroup.manifests],
            []
        );
        const manifests = [].concat(...allManifests);

        let selAbnManIds = [];
        let selManIds = [];
        let abnManifestIds = map(manifests, m => m.abnormalityManifestId);
        let manifestIds = map(manifests, m => m.manifest.manifestId);

        selAbnManIds = allManifestsSelected
            ? union(selAbnManIds, abnManifestIds)
            : pullAll(selAbnManIds, abnManifestIds);
        selManIds = allManifestsSelected
            ? union(selManIds, manifestIds)
            : pullAll(selManIds, manifestIds);

        if (this.state.validations.manifests) {
            let tempVal = this.state.validations;
            delete tempVal.manifests;
            this.setState({ validations: tempVal });
        }

        if (this.state.validations.pallets) {
            let tempVal = this.state.validations;
            delete tempVal.pallets;
            this.setState({ validations: tempVal });
        }

        this.setState({
            allManifestsSelected: allManifestsSelected,
            selectedAbnManifestIds: selAbnManIds,
            selectedManifestIds: selManIds,
        });
    };

    render() {
        const { abnormalityAnalysis, isFetching } = this.props;
        const {
            allManifestsSelected,
            openTapModal,
            openPullForwardModal,
            openSpecialModal,
            openSlideModal,
            openUnrelatedManifestsModal,
            validations,
            selectedAbnManifestIds,
            selectedManifestIds,
        } = this.state;

        const hasStatusCancelled =
            abnormalityAnalysis && abnormalityAnalysis.abnormalityStatus === 'CANCELLED';
        const hasStatusClosed =
            abnormalityAnalysis && abnormalityAnalysis.abnormalityStatus === 'CLOSED';

        if (isFetching) {
            return <Loader />;
        }

        return (
            <Row>
                {abnormalityAnalysis && createAbnormalityAnalysisBreadcrumb(abnormalityAnalysis)}
                <Col lg={12} md={12} sm={12}>
                    <Row>
                        <RouteInfo
                            colSize={6}
                            routeCode={abnormalityAnalysis && abnormalityAnalysis.routeCode}
                            runDate={abnormalityAnalysis && abnormalityAnalysis.runDate}
                            runSeq={abnormalityAnalysis && abnormalityAnalysis.runSequence}
                        />
                        <Col sm={6}>
                            <Row>
                                <AssigneeInfo
                                    colSize={12}
                                    assignee={abnormalityAnalysis && abnormalityAnalysis.assignee}
                                    assigneeGroup={
                                        abnormalityAnalysis &&
                                        abnormalityAnalysis.groupRoleAssignees
                                    }
                                />
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Row>
                                <Col sm={12}>
                                    <AbnormalityInfo
                                        isAnalysis={true}
                                        isEditable={false}
                                        selectedDate={
                                            abnormalityAnalysis
                                                ? moment(abnormalityAnalysis.abnormalityDate)
                                                : moment()
                                        } // initial render is null that's why better parse moment()
                                        selectedStop={
                                            abnormalityAnalysis &&
                                            abnormalityAnalysis.abnormalityStop
                                        }
                                        trailerIdentifier={
                                            abnormalityAnalysis &&
                                            abnormalityAnalysis.trailerIdentifier
                                        }
                                        abnormalityType={
                                            abnormalityAnalysis &&
                                            abnormalityAnalysis.abnormalityType
                                        }
                                        abnormalityStatus={
                                            abnormalityAnalysis &&
                                            abnormalityAnalysis.abnormalityStatus
                                        }
                                        abnormalityStop={
                                            abnormalityAnalysis && abnormalityAnalysis.stop.stopName
                                        }
                                    />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Reasons
                                isEditable={false}
                                selectedReason={abnormalityAnalysis && abnormalityAnalysis.reason}
                            />
                        </Col>
                    </Row>
                    {abnormalityAnalysis &&
                        abnormalityAnalysis.abnormalityType === ABNORMALITIES.BLOWOUT && (
                            <Row>
                                <Col sm={12}>
                                    <BlowoutRepetitions
                                        blowoutRepetitions={
                                            abnormalityAnalysis &&
                                            abnormalityAnalysis.blowoutRepetitions
                                        }
                                    />
                                </Col>
                            </Row>
                        )}
                    <Row>
                        <Col sm={12}>
                            <Button
                                bsStyle="primary"
                                style={{ marginBottom: 20 }}
                                onClick={this.selectAllManifestsForAllManifestGroups}
                            >
                                {allManifestsSelected
                                    ? 'Unselect all manifests'
                                    : 'Select all manifests across all groups'}
                            </Button>
                        </Col>
                        {abnormalityAnalysis &&
                            abnormalityAnalysis.manifestGroups &&
                            map(abnormalityAnalysis.manifestGroups, (manifestGroup, index) => (
                                <Col key={index} sm={12}>
                                    <Well>
                                        <h4>Manifest group {replaceArrow(manifestGroup.name)}</h4>
                                        <Row>
                                            <Col sm={12}>
                                                <Panel>
                                                    <ManifestTimeline
                                                        previousRun={manifestGroup.previousRun}
                                                        plannedRun={manifestGroup.plannedRun}
                                                        nextRun={manifestGroup.nextRun}
                                                    />
                                                </Panel>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={12}>
                                                <AbnormalityManifestsTable
                                                    hideSeverity={
                                                        abnormalityAnalysis &&
                                                        hideSeverityColumn(
                                                            abnormalityAnalysis.abnormalityType,
                                                            true
                                                        )
                                                    }
                                                    manifests={manifestGroup.manifests}
                                                    selectedAbnManifestIds={selectedAbnManifestIds}
                                                    validations={validations}
                                                    onCheckSelect={
                                                        this.handleSingleManifestSelection
                                                    }
                                                    onCheckSelectAll={
                                                        this.handleAllManifestsSelection
                                                    }
                                                />
                                            </Col>
                                        </Row>
                                    </Well>
                                </Col>
                            ))}
                    </Row>
                    {!hasStatusCancelled &&
                        !hasStatusClosed && (
                            <Row>
                                <Col sm={12}>
                                    <Well>
                                        <Row>
                                            <Col sm={12}>
                                                {validations.moreThan10Pallets && (
                                                    <Alert bsStyle="info">
                                                        {validations.moreThan10Pallets}
                                                    </Alert>
                                                )}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm={4}>
                                                <Button
                                                    bsStyle="primary"
                                                    style={{ margin: 10 }}
                                                    onClick={() =>
                                                        this.handleOpenModal(
                                                            'openUnrelatedManifestsModal'
                                                        )
                                                    }
                                                >
                                                    Plan recovery action with other manifests
                                                </Button>
                                            </Col>
                                            <Col sm={8}>
                                                <div className="pull-right">
                                                    <Button
                                                        bsStyle="success"
                                                        style={{
                                                            margin: 10,
                                                            width: 120,
                                                        }}
                                                        onClick={() =>
                                                            this.handleOpenModal(
                                                                'openPullForwardModal'
                                                            )
                                                        }
                                                    >
                                                        Pull forward
                                                    </Button>
                                                    <Button
                                                        bsStyle="success"
                                                        style={{
                                                            margin: 10,
                                                            width: 120,
                                                        }}
                                                        onClick={() =>
                                                            this.handleOpenModal('openSlideModal')
                                                        }
                                                    >
                                                        Slide
                                                    </Button>
                                                    <Button
                                                        bsStyle="success"
                                                        style={{
                                                            margin: 10,
                                                            width: 120,
                                                        }}
                                                        onClick={() =>
                                                            this.handleOpenModal('openSpecialModal')
                                                        }
                                                    >
                                                        Special
                                                    </Button>
                                                    <Button
                                                        bsStyle="success"
                                                        style={{
                                                            margin: 10,
                                                            width: 120,
                                                        }}
                                                        onClick={() =>
                                                            this.handleOpenModal('openTapModal')
                                                        }
                                                    >
                                                        Tap
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Well>
                                </Col>
                            </Row>
                        )}
                    {openTapModal && (
                        <TapModal
                            showModal={openTapModal}
                            abnormalityAnalysis={abnormalityAnalysis}
                            runId={this.props.params.id}
                            manifestGroups={
                                abnormalityAnalysis && abnormalityAnalysis.manifestGroups
                            }
                            selectedAbnManifestIds={selectedAbnManifestIds}
                            selectedManifestIds={selectedManifestIds}
                            arrivalDate={abnormalityAnalysis && abnormalityAnalysis.runDate}
                            onClose={() => this.handleCloseModal('openTapModal')}
                            onHide={() => this.handleCloseModal('openTapModal')}
                            backdrop="static"
                        />
                    )}
                    {openPullForwardModal && (
                        <SlidePullModal
                            showModal={openPullForwardModal}
                            isPullForward
                            runId={this.props.params.id}
                            abnormalityAnalysis={abnormalityAnalysis}
                            manifestGroups={
                                abnormalityAnalysis && abnormalityAnalysis.manifestGroups
                            }
                            selectedAbnManifestIds={selectedAbnManifestIds}
                            selectedManifestIds={selectedManifestIds}
                            arrivalDate={abnormalityAnalysis && abnormalityAnalysis.runDate}
                            validations={validations}
                            onClose={() => this.handleCloseModal('openPullForwardModal')}
                            onHide={() => this.handleCloseModal('openPullForwardModal')}
                            backdrop="static"
                        />
                    )}
                    {openSpecialModal && (
                        <SpecialModal
                            showModal={openSpecialModal}
                            abnormalityAnalysis={abnormalityAnalysis}
                            selectedAbnManifestIds={selectedAbnManifestIds}
                            selectedManifestIds={selectedManifestIds}
                            onClose={() => this.handleCloseModal('openSpecialModal')}
                            onHide={() => this.handleCloseModal('openSpecialModal')}
                            backdrop="static"
                        />
                    )}
                    {openSlideModal && (
                        <SlidePullModal
                            showModal={openSlideModal}
                            runId={this.props.params.id}
                            abnormalityAnalysis={abnormalityAnalysis}
                            manifestGroups={
                                abnormalityAnalysis && abnormalityAnalysis.manifestGroups
                            }
                            selectedAbnManifestIds={selectedAbnManifestIds}
                            selectedManifestIds={selectedManifestIds}
                            arrivalDate={abnormalityAnalysis && abnormalityAnalysis.runDate}
                            validations={validations}
                            onClose={() => this.handleCloseModal('openSlideModal')}
                            onHide={() => this.handleCloseModal('openSlideModal')}
                            backdrop="static"
                        />
                    )}
                    {openUnrelatedManifestsModal && (
                        <UnrelatedManifestsModal
                            showModal={openUnrelatedManifestsModal}
                            abnormalityId={this.props.params.abnormalityId}
                            onClose={() => this.handleCloseModal('openUnrelatedManifestsModal')}
                            onHide={() => this.handleCloseModal('openUnrelatedManifestsModal')}
                        />
                    )}
                </Col>
            </Row>
        );
    }
}

export default withRouter(
    connect(
        (state, props) => ({
            abnormalityAnalysis: getAbnormalityAnalysis(state, props.params.abnormalityId),
            isFetching: getIsFetching(state),
            isPending: getIsPending(state),
            isRejected: getError(state),
        }),
        { loadAbnormalityAnalysis, clearManifests }
    )(CreateRecoveryAction)
);
